import React from 'react';
import MoveBasicButton from '../Button/MoveBasicButton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Error = ({ errorType }) => {
  const { t } = useTranslation();

  let title, desc;

  switch (errorType) {
    case '404':
      title = `${t('404_title')}.`;
      desc = `${t('404_desc')}.`;
      break;
    case '500':
      title = `${t('500_title')}.`;
      desc = `${t('500_desc')}.`;
      break;
    default:
      title = `${t('404_title')}.`;
      desc = `${t('404_desc')}.`;
  }

  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <>
      <div className={'ml-page error-page pt-80'}>
        <div className='page-inner'>
          <div className='error-items-wrapper'>
            <figure className='error-img-group'>
              <img src='/img_error.png' alt='error image' className={'error-img'} />
            </figure>
            <div className='error-txt-group'>
              <h3 className={'error-title'}>{title}</h3>
              <p className={'error-desc'}>{desc}</p>
            </div>
            <div className='error-button-group'>
              <MoveBasicButton buttonTxt={t('go_back_home')} onClick={handleHomeClick} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error;
